import React from 'react';

const Modal = ({ text, title, closeText, closeFunction, modalType }) => {
    let iconSrc;
    switch (modalType) {
        case "hint":
            iconSrc = './img/icon-bulb.png';
            break;
        case "correct":
            iconSrc = './img/icon-correct.png';
            break;
        case 'incorrect':
            iconSrc = './img/icon-incorrect.png';
            break;
        default:
            iconSrc = './img/icon-bulb.png';
    }
    return (
        <div className="modal">

            <div className="modal-inner">
                <img className="modal-icon" src={iconSrc} alt=""/>
                <h1 className="modal-title">{title}</h1>
                <p className="modal-text">{text}</p>
            </div>

            <div className='App__button-large-container modal-close'>
                <button onClick={() => { closeFunction(false) }}>
                    {closeText}
                </button>
            </div>

        </div>
    )
};

export default Modal;
